import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import common from "./slices/common";
import registration from "./slices/registration";
import stage1 from "./slices/stage1";
import stage2 from "./slices/stage2";
import stage3 from "./slices/stage3";
import stage4 from "./slices/stage4";
import stage5 from "./slices/stage5";
import stage6 from "./slices/stage6";
import stage7 from "./slices/stage7";
import stage8 from "./slices/stage8";

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

// const productPersistConfig = {
//   key: 'product',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy', 'checkout']
// };

const rootReducer = combineReducers({
  common,
  registration,
  stage1,
  stage2,
  stage3,
  stage4,
  stage5,
  stage6,
  stage7,
  stage8,
});

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export { rootPersistConfig, rootReducer, persistedReducer };
